export default __webpack_public_path__ + "static/home-icon-933ae69cc0f52a4ace9aac20beea48d8.png";